<template>
  <div>
    <div ref="seatsContainer" id="seats_container"></div>
  </div>
</template>

<script>
  import moment from 'moment';
  import axios from 'axios';
  import { configApi } from '../../api/configApi';
  import { headers } from '../../api/headers';
  import * as d3 from 'd3';
  import { first } from 'lodash';
  import { index } from 'd3';

  export default {
    name: 'boletas',
    props: [
      'idlocalidad',
      'idEvento',
      'pagos',
      'fisico',
      'monedaEvento',
      'indexMonedaSelectShopEvento',
      'simboloMoneda',
      'monedasEvento',
      'cantselect',
      'restarSelect',
    ],
    data() {
      return {
        datos: [],
        colorSeat: '',
        color: '#0089D2',
        selectedColorOcupados: '#FF5252',
        selectedColorSelect: '#339966',
        selectedColorFondo: '#FAFAFA',
        valida_venta_estado: null,
        cant_max_puestos: '',
        tipo_individual: 0,
        snackbar: false,
        timeout: 2000,
        cantidad_mostrar: null,
        numero_palco: 0,
        cant_palco_individual: 0,
        puestos_disponibles_palco: null,
        modalCosto: false,
        modalfechacupos: false,
        fechaventa: '',
        fechacupon: '',
        validarcupon: false,
        validarcuponfecha: false,
        cupon: '',
        validandocupon: false,
        ideventocup: 0,
        boleta: '',
        elhtml: '',
        precio: 0,
        disponibles: 0,
        reservados: 0,
        pagos_parcial: 0,
        ocupados: 0,
        inhabilitados: 0,
        palco_evento: [],
        id_boleta: 0,
        accionPuesto: {
          nota: null,
          created_at: null,
        },
        cantidad_individuales: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        datos_seat: [
          {
            tipo: null,
            status: null,
            precio_venta: 0,
            precio_servicio: 0,
          },
        ],
        entregaBoletas: 'digital',
      };
    },
    async created() {
      this.datos = [];
      const filtro = {
        id_evento: this.idEvento,
        id_localidad: this.idlocalidad,
      };

      const siexite = JSON.parse(localStorage.getItem('vuex'));
      if (siexite.user.accessToken == null) {
        var ruta = 'eventos/' + this.currentRoute + '/' + this.evento.slug;
        localStorage.setItem('rutalogin', ruta);
      } else {
        localStorage.removeItem('rutalogin');
      }

      await axios
        .post(`${configApi.apiUrl}ger_mapeo_localidad`, filtro, {
          headers: headers,
        })
        .then((response) => {
          this.palco_evento = response.data.puestos_palco;
          this.datos = response.data.resultado;
          this.color = response.data.resultado[0].coloractivos;
          this.selectedColorOcupados = response.data.resultado[0].colorocupados;
          this.selectedColorSelect = response.data.resultado[0].colorselect;
          this.selectedColorFondo = response.data.resultado[0].colorfondo;

          this.$emit('valorlocalidad', this.datos);
          this.cargarMapeo();
        });
    },
    methods: {
      async refrescarvalorwidget() {
        var cupon = 'NA';
        if (
          this.currentRoute != 'evento' ||
          this.evento.fechaValidaInicioInternet
        ) {
          if (this.$store.getters['user/dataUserLogged'].nombre == null) {
            //this.$router.push({ path: "/login" })
            //window.location.push("/login")
            //location.replace('/login')
            //this.$store.state.modalLogin = true;
          } else {
            if (
              this.entregaBoletas != null &&
              this.entregaBoletas != undefined
            ) {
              var lasBoletas = [];
              var losPalcos = [];

              for (
                var i = 0;
                i < this.listLocalidadesEventoAuditorio_mapeado.length;
                i++
              ) {
                if (
                  this.$store.state.carrito.cantBoleta[
                    this.listLocalidadesEventoAuditorio_mapeado[i].id
                  ] != null
                ) {
                  if (
                    this.listLocalidadesEventoAuditorio_mapeado[i].palco == 1
                  ) {
                    losPalcos = losPalcos.concat(
                      this.$store.state.carrito.cantBoleta[
                        this.listLocalidadesEventoAuditorio_mapeado[i].id
                      ]
                    );
                  } else {
                    lasBoletas = lasBoletas.concat(
                      this.$store.state.carrito.cantBoleta[
                        this.listLocalidadesEventoAuditorio_mapeado[i].id
                      ]
                    );
                  }
                  this.$store.state.carrito.cantBoleta[
                    this.listLocalidadesEventoAuditorio_mapeado[i].id
                  ].length;
                }
              }
              if (lasBoletas != [] || losPalcos != []) {
                if (this.$store.state.carrito.cupon != null) {
                  cupon = this.$store.state.carrito.cupon;
                }

                //Eliminar Duplicidad ID
                const duplicidadPalcos = new Set(losPalcos);
                let resultDupliPalcos = [...duplicidadPalcos];

                const duplicidadBoletas = new Set(lasBoletas);
                let resultDupliBoletas = [...duplicidadBoletas];

                await this.$store
                  .dispatch('resumen_Boletas_compra', {
                    palcos:
                      resultDupliPalcos.length > 0 ? resultDupliPalcos : '',
                    boletas:
                      resultDupliBoletas.length > 0 ? resultDupliBoletas : '',
                    cupon: cupon.length > 2 ? cupon : 'NA',
                    funcionseleccionada:
                      localStorage.getItem('funcionselected'),
                    protectionValue: this.$store.state.protectionValue,
                    pgwidget: this.$store.state.pgwidget,
                    productId: this.$store.state.productId,
                    sold: this.$store.state.sold,
                  })
                  .then(() => {
                    if (this.$store.state.errorDetalleCompra) {
                      //swal("Parece que algo salio mal!", "Intentalo nuevamente", "error");
                      return '';
                    } else {
                      for (
                        let index = 0;
                        index <
                        this.$store.state.resumenFinalizarCompra.productos
                          .length;
                        index++
                      ) {
                        if (
                          this.$store.state.resumenFinalizarCompra.productos[
                            index
                          ].color === ''
                        ) {
                          this.$store.state.resumenFinalizarCompra.productos[
                            index
                          ].color = this.colorSeat;
                        }
                      }

                      this.$store.state.showModalFinalizarCompra = true;

                      var cantidadDinero =
                        this.$store.state.resumenFinalizarCompra.totalVenta;
                      cantidadDinero = cantidadDinero
                        .replace(/[^0-9,]/g, '')
                        .replace(',', '.');

                      this.numeropuestoscompra =
                        this.$store.state.resumenFinalizarCompra.numeropuestoscompra;

                      this.valortotalcompra =
                        this.$store.state.resumenFinalizarCompra.totalVenta;
                      this.cartsubtotal = parseFloat(cantidadDinero);

                      this.$store.state.totalValue = parseFloat(cantidadDinero);
                    }
                  });
              }
            } else {
              this.modalSelectEntregaBoletas = true;
            }
          }
        } else {
          swal(
            'Error!',
            'Ventas en linea disponible despues de ' +
              this.formatDatetimeString(
                this.evento.fecha_inicio_venta_internet_formateada
              ),
            'error'
          );
        }
      },
      findPuesto() {
        const idToFind = parseInt(this.id_boleta);
        for (let fila of this.boletaslocalidad.palcos) {
          const puesto = fila.palco_eventos.find((p) => p.id == idToFind);
          if (puesto) {
            this.boleta = puesto;
            return;
          }
        }

        this.boleta = null;
      },
      emitirEventoUpdParticipantes() {
        this.$emit('informacion-enviada', '1');
      },
      mostrarPuestosDisponibles(palco, numero) {
        this.snackbar = false;
        this.numero_palco = numero;
        this.cantidad_mostrar = 'Cargando...';
        // this.cantidad_mostrar = 0
        if (palco.palco_eventos[0].status === 12) {
          axios
            .get(
              configApi.apiUrl +
                'puestospalcoevento/' +
                palco.palco_eventos[0].id,
              headers
            )
            .then((response) => {
              if (response.data.data.length == 0) {
                this.cantidad_mostrar = 'No hay puestos disponibles';
              } else {
                this.cantidad_mostrar = response.data.data.length;
              }
            })
            .catch((e) => {
              this.cantidad_mostrar = 'No hay puestos disponibles';
            });
          this.snackbar = true;
        }
      },
      formatNumber(number) {
        return new Intl.NumberFormat('es-CO', {
          minimumFractionDigits: 0,
        }).format(number);
      },
      formatDatetimeString(datetime) {
        if (datetime != null && datetime != '') {
          return moment(datetime).format('dddd Do [de] MMMM [a las] hh:mm a');
        } else {
          return '';
        }
      },
      async setCantBoleta(operacion, localidad, boleta) {
        if (this.$store.getters['user/dataUserLogged'].nombre == null) {
          this.$store.state.modalLogin = true;
          return false;
          //swal("Error!", "Debe Iniciar Sesión!", "error");
        }

        this.valida_venta_estado = 0;

        await axios
          .get(configApi.apiUrl + 'valida_ventas_activas', headers)
          .then((response) => {
            this.valida_venta_estado = response.data[0].cantidad;
          });

        if (this.valida_venta_estado > 0) {
          swal(
            '¡Tiene una transacción pendiente!',
            'Tiene una transacción pendiente de pago, intente nuevamente después de 15 minutos',
            'warning'
          );
          return;
        }

        if (
          this.puestos_disponibles_palco == 0 &&
          operacion == 'sumarIndividual'
        ) {
          swal(
            '¡No hay puestos disponibles!',
            'Todos los puestos han sido ocupados.',
            'warning'
          );
          return;
        }

        if (
          this.currentRoute != 'evento' ||
          this.evento.fechaValidaInicioInternet ||
          this.$store.state.carrito.cuponestado
        ) {
          if (this.$store.getters['user/dataUserLogged'].nombre == null) {
            this.$store.state.modalLogin = true;
            return false;
            //swal("Error!", "Debe Iniciar Sesión!", "error");
          }
          if (
            operacion == 'restar' ||
            this.evento.cant_max_boletas > this.cantBoletaTotal ||
            this.evento.cant_max_boletas == 0 ||
            this.evento.cant_max_boletas == null
          ) {
            if (
              operacion == 'restar' &&
              this.countBoletas <= 0 &&
              this.countPalcos <= 0
            ) {
              return;
            }
            if (
              operacion == 'sumar' &&
              this.listBoletasLocalidadDisponibilidad.disponibles <= 0
            ) {
              swal(
                '¡Localidad Agotada!',
                'No hay boletas disponibles para esta localidad.',
                'warning'
              );
              return;
            }

            if (
              operacion == 'sumar' &&
              this.countBoletas > this.evento.cant_max_boletas
            ) {
              swal(
                'Cantidad Máxima',
                'Ha excedido la cantidad máxima de boletas por transacción.',
                'warning'
              );
              return;
            }

            if (boleta.id_palco > 0) {
              var setCantBoletaApi = await this.$store.dispatch(
                'evento/setCantBoleta',
                {
                  operacion: operacion,
                  palco: this.boletaslocalidad.palco,
                  id_evento: this.idEvento,
                  id_localidad: this.boletaslocalidad.id,
                  precio: this.precio,
                  id_palco: boleta.id_palco,
                }
              );
            } else {
              var setCantBoletaApi = await this.$store.dispatch(
                'evento/setCantBoleta',
                {
                  operacion: operacion,
                  palco: this.boletaslocalidad.palco,
                  id_evento: this.idEvento,
                  id_localidad: this.boletaslocalidad.id,
                  precio: this.precio,
                }
              );
            }

            if (setCantBoletaApi) {
              this.getPalcosIndividualesUsuario(boleta.id_palco);
              this.getPuestosPalcos(boleta.id);
            }

            //this.$store.dispatch('carrito/preciosBoletasCarrito',this.preciosBoletasLocalidadDescuento);
            if (operacion == 'restar') {
              this.$store.dispatch('carrito/restartBoletaCarrito', {
                localidad_id: this.boletaslocalidad.id,
                monedasEvento: this.monedasEvento,
              });
            } else if (operacion == 'sumar') {
              if (setCantBoletaApi.message != 'error') {
                this.preciosBoletasLocalidadDescuento(
                  this.boletaslocalidad.palco
                );
              } else {
                if (this.boletaslocalidad.palco) {
                  var mensaje = 'No hay más palcos disponibles!';
                } else {
                  var mensaje = 'No hay más boletas disponibles!';
                }

                if (setCantBoletaApi.data.tope) {
                  var mensajeError =
                    'Usuario excedió el límite máximo de boletas que puede comprar para este evento. Código :002A';
                }

                swal('Error!', mensaje, 'warning');
              }
              if (
                this.dateTimeSaleStart == null &&
                this.dateTimeSaleEnd == null
              ) {
                var fechaInicioVenta = new Date();
                this.$store.dispatch(
                  'carrito/dateTimeSaleStart',
                  fechaInicioVenta
                );
                let fecha = new Date();
                var fechaFinVenta = new Date(
                  fecha.getFullYear(),
                  fecha.getMonth(),
                  fecha.getDate(),
                  fecha.getHours(),
                  fecha.getMinutes(),
                  fecha.getSeconds() + 600
                );
                this.$store.dispatch('carrito/dateTimeSaleEnd', fechaFinVenta);
              }
            }

            //actualiza la grafica de las boletas
            await this.$store.dispatch('localidad/listBoletasLocalidad', {
              id_localidad: this.idlocalidad,
              id_evento: this.idEvento,
              codigo_moneda: this.monedaEvento,
            });
          } else {
            swal(
              '¡Alcanzó el tope por día!',
              'Supera el tope de boletas por día',
              'warning'
            );
          }
        } else {
          this.modalfechacupos = true;
          this.fechaventa = this.formatDatetimeString(
            this.evento.fecha_inicio_venta_internet_formateada
          );
          this.fechacupon = this.formatDatetimeString(
            this.evento.fecha_inicio_venta_cupon_formateada
          );
          this.ideventocup = this.evento.id_evento;
          this.validarcupon = false;
          this.validarcuponfecha = false;
          if (this.evento.cupon == 'true') {
            this.validarcupon = true;
          }
          if (this.evento.fechaValidaInicioCuponVenta == 1) {
            this.validarcuponfecha = true;
          }
          // swal(
          //   "Error!",
          //   "Ventas en linea disponible despues de " +
          //     this.formatDatetimeString(
          //       this.evento.fecha_inicio_venta_internet_formateada
          //     ),
          //   "error"
          // );
        }
      },
      async clearCantBoletaLocalidad() {
        this.$store.dispatch('evento/clearCantBoletaLocalidad', {
          id: this.boletaslocalidad.id,
          precio: this.precio,
        });
      },
      async clearCantBoleta() {
        if (
          this.preciosBoletasCarrito &&
          this.preciosBoletasCarrito.length > 0
        ) {
          var lasBoletas = [];
          var losPalcos = [];

          for (
            var i = 0;
            i < this.listLocalidadesEventoAuditorio_mapeado.length;
            i++
          ) {
            if (
              this.cantBoleta[
                this.listLocalidadesEventoAuditorio_mapeado[i].id
              ] != null
            ) {
              if (this.listLocalidadesEventoAuditorio_mapeado[i].palco == 1) {
                losPalcos = losPalcos.concat(
                  this.cantBoleta[
                    this.listLocalidadesEventoAuditorio_mapeado[i].id
                  ]
                );
              } else {
                lasBoletas = lasBoletas.concat(
                  this.cantBoleta[
                    this.listLocalidadesEventoAuditorio_mapeado[i].id
                  ]
                );
              }
              this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]
                .length;
            }
          }

          await this.$store.dispatch('carrito/setNullReservas', {
            boletas: lasBoletas,
            palcos: losPalcos,
          });

          this.$store.dispatch('evento/clearCantBoleta');
        } else {
          swal('Error!', 'El carrito esta vacio!', 'error');
        }
      },
      async getPuestosPalcos(id) {
        await axios
          .get(configApi.apiUrl + 'puestospalcoevento/' + id, headers)
          .then((response) => {
            if (response.data.data.length == 0) {
              this.puestos_disponibles_palco = '0';
            } else {
              this.puestos_disponibles_palco = response.data.data.length;
            }
          })
          .catch((e) => {
            this.puestos_disponibles_palco = '0';
          });
      },
      async getPalcosIndividualesUsuario(id) {
        await axios
          .get(configApi.apiUrl + 'puestosindividualesusuario/' + id, headers)
          .then((response) => {
            this.cant_palco_individual = response.data.cantidad;
          });
      },
      async getCantMaxPuestosPalco(id) {
        await axios
          .get(configApi.apiUrl + 'cantmaxpuestospalco/' + id, headers)
          .then((response) => {
            this.cant_max_puestos = response.data[0].cantidad;
          });
      },
      async getBoleta(boleta, numero) {
        this.cant_palco_individual = 0;
        this.cant_max_puestos = '';
        this.getPuestosPalcos(boleta.id);
        this.getPalcosIndividualesUsuario(boleta.id_palco);
        this.getCantMaxPuestosPalco(boleta.id_palco);

        if (boleta.status == 12) {
          this.tipo_individual = 12;
        } else {
          this.tipo_individual = 0;
        }

        if (this.currentRoute == 'CortesiasEventoJefePuntoVenta') {
          if (boleta.status > 1 && boleta.status != 12) {
            return;
          }

          this.boleta = boleta;
          this.boleta.numero_puesto = numero;
          this.modalCosto = true;
        } else if (this.currentRoute == 'MapeoEventoJefePuntoVenta') {
          if (boleta.status != 1 && boleta.status != 4) {
            return;
          }

          var tipoBoleta = '';
          if (this.boletaslocalidad.palco != 1) {
            tipoBoleta = 'boleta';
          } else {
            tipoBoleta = 'palco';
          }

          this.accionPuesto.nota = null;
          this.accionPuesto.created_at = null;

          if (boleta.status == 4) {
            this.accionPuesto = await this.$store.dispatch(
              'puesto/getAccionPuesto',
              {
                tipo_boleta: tipoBoleta,
                id_boleta: boleta.id,
              }
            );
          }

          this.boleta = boleta;
          this.boleta.numero_puesto = numero;
          this.modalCosto = true;
        } else {
          if (boleta.status > 1 && boleta.status != 12) {
            return;
          }
          // await this.$store.dispatch("puesto/getPrecio", {
          //   id_evento: boleta.id_evento,
          //   precio_venta: boleta.precios_monedas[0].precio_venta,
          //   precio_servicio: boleta.precios_monedas[0].precio_servicio,
          //   impuesto: boleta.impuesto,
          //   id_tribuna: this.boletaslocalidad.id_tribuna,
          //   id_localidad: this.boletaslocalidad.id,
          //   codigo_moneda: this.monedaEvento,
          // });
          this.precio = this.getPrecioBoleta(); // await this.$store.getters["puesto/viewPrecio"];
          this.boleta = boleta;
          this.boleta.numero_puesto = numero;
          this.modalCosto = true;
        }
      },

      async cerrarmodalfechacupon() {
        this.modalfechacupos = false;
      },
      async getvalidarcupon() {
        if (this.$store.getters['user/dataUserLogged'].nombre == null) {
          this.$store.state.modalLogin = true;
          //swal("Error!", "Debe Iniciar Sesión!", "error");
        } else {
          this.validandocupon = true;
          if (this.cupon.length == 0) {
            swal('Validar Cupón', 'Debe Indicar un Cupon!', 'warning');
            this.validandocupon = false;
            return;
          }
          await this.$store.dispatch('evento/getvalidarcuponventa', {
            id_evento: this.idEvento,
            cupon: this.cupon,
          });

          if (this.$store.state.carrito.cuponestado == 1) {
            // this.validarcupon=false
            // this.cuponok=true
          } else {
            this.$store.state.carrito.cupon = null;
            swal(
              'Cupón no válido',
              'Cupón no válido o ya fue usado.',
              'warning'
            );
          }
          this.validandocupon = false;
        }
      },
      async Sumar_reserva() {
        //lamt_reservar
        this.valida_venta_estado = 0;

        if (this.$store.getters['user/dataUserLogged'].nombre == null) {
          this.$store.state.modalLogin = true;
          return false;
          //swal("Error!", "Debe Iniciar Sesión!", "error");
        }
        await axios
          .get(configApi.apiUrl + 'valida_ventas_activas', headers)
          .then((response) => {
            this.valida_venta_estado = response.data[0].cantidad;
          });

        if (this.valida_venta_estado > 0) {
          swal(
            '¡Tiene una transacción pendiente!',
            'Tiene una transacción pendiente de pago, intente nuevamente después de 15 minutos',
            'warning'
          );
          return;
        }

        if (
          this.currentRoute != 'evento' ||
          this.evento.fechaValidaInicioInternet ||
          this.$store.state.carrito.cuponestado
        ) {
          if (this.$store.getters['user/dataUserLogged'].nombre == null) {
            this.$store.state.modalLogin = true;
            //swal("Error!", "Debe Iniciar Sesión!", "error");
          } else {
            if (this.countPalcos < 2) {
              // await this.$store.dispatch('carrito/listBoletas',{
              // 	id: this.boleta.id,
              // 	id_evento: this.boleta.id_evento,
              // 	id_puesto: this.boleta.id_puesto,
              //     precio_venta: this.boleta.precio_venta,
              //     precio_servicio: this.boleta.precio_servicio,
              //     impuesto: this.boleta.impuesto,
              //     status: 2,
              //     codigo_moneda: this.boleta.codigo_moneda,
              // });
              //lamt 3
              await this.$store
                .dispatch('evento/setCantBoleta', {
                  operacion: 'sumar',
                  palco: '',
                  id_evento: this.idEvento,
                  id_localidad: this.idlocalidad,
                  palco_status: 1,
                  cantidad: this.cantselect,
                  metodo: 'nuevo',
                })
                .then((response) => {
                  if (response.message != 'error') {
                    this.preciosBoletasLocalidadDescuento(this.datos_seat.tipo);
                    this.$emit('reiniciarselect', null);
                    this.refrescarvalorwidget();
                    if (
                      this.dateTimeSaleStart == null &&
                      this.dateTimeSaleEnd == null
                    ) {
                      var fechaInicioVenta = moment().format('Y-MM-D HH:mm:s');
                      this.$store.dispatch(
                        'carrito/dateTimeSaleStart',
                        fechaInicioVenta
                      );
                      var fechaFinVenta = moment()
                        .add(10, 'minutes')
                        .format('Y-MM-D HH:mm:s');
                      this.$store.dispatch(
                        'carrito/dateTimeSaleEnd',
                        fechaFinVenta
                      );
                    }
                  } else {
                    if (this.datos_seat.tipo == 1) {
                      var mensajeError =
                        'Error, transaccion en progreso por otro usuario. Escoge otro palco.';
                    } else {
                      var mensajeError =
                        'Error, transaccion en progreso por otro usuario. Escoge otra boleta.';
                    }

                    if (response.data.tope) {
                      var mensajeError =
                        'Usuario excedió el límite máximo de boletas que puede comprar para este evento. Código :002A';
                    }

                    swal('Error!', mensajeError, 'error');
                  }
                });

              //this.$store.dispatch('carrito/preciosBoletasCarrito',this.preciosBoletasLocalidadDescuento);

              //actualiza la grafica de las boletas
              this.$store.dispatch('localidad/listBoletasLocalidad', {
                id_localidad: this.idlocalidad,
                id_evento: this.idEvento,
                codigo_moneda: this.monedaEvento,
              });
              if (this.boleta.status != 12) {
                this.modalCosto = false;
              }
            } else {
              swal(
                'Mensaje',
                'Ha excedido la cantidad maxima de palcos por transacción.',
                'warning'
              );
            }
          }
        } else {
          this.modalfechacupos = true;
          this.fechaventa = this.formatDatetimeString(
            this.evento.fecha_inicio_venta_internet_formateada
          );
          this.fechacupon = this.formatDatetimeString(
            this.evento.fecha_inicio_venta_cupon_formateada
          );
          this.ideventocup = this.evento.id_evento;
          this.validarcupon = false;
          this.validarcuponfecha = false;
          if (this.evento.cupon == 'true') {
            this.validarcupon = true;
          }
          if (this.evento.fechaValidaInicioCuponVenta == 1) {
            this.validarcuponfecha = true;
          }
        }
      },
      async reservar() {
        //lamt_reservar
        this.valida_venta_estado = 0;

        if (this.$store.getters['user/dataUserLogged'].nombre == null) {
          this.$store.state.modalLogin = true;
          return false;
          //swal("Error!", "Debe Iniciar Sesión!", "error");
        }
        await axios
          .get(configApi.apiUrl + 'valida_ventas_activas', headers)
          .then((response) => {
            this.valida_venta_estado = response.data[0].cantidad;
          });

        if (this.valida_venta_estado > 0) {
          swal(
            '¡Tiene una transacción pendiente!',
            'Tiene una transacción pendiente de pago, intente nuevamente después de 15 minutos',
            'warning'
          );
          return;
        }

        if (
          this.currentRoute != 'evento' ||
          this.evento.fechaValidaInicioInternet ||
          this.$store.state.carrito.cuponestado
        ) {
          if (this.$store.getters['user/dataUserLogged'].nombre == null) {
            this.$store.state.modalLogin = true;
            //swal("Error!", "Debe Iniciar Sesión!", "error");
          } else {
            if (this.countPalcos < 2) {
              // await this.$store.dispatch('carrito/listBoletas',{
              // 	id: this.boleta.id,
              // 	id_evento: this.boleta.id_evento,
              // 	id_puesto: this.boleta.id_puesto,
              //     precio_venta: this.boleta.precio_venta,
              //     precio_servicio: this.boleta.precio_servicio,
              //     impuesto: this.boleta.impuesto,
              //     status: 2,
              //     codigo_moneda: this.boleta.codigo_moneda,
              // });
              //lamt 3
              await this.$store
                .dispatch('evento/setCantBoleta', {
                  operacion: 'reservar',
                  palco: this.datos_seat.tipo,
                  id_evento: this.idEvento,
                  id_localidad: this.idlocalidad,
                  id_boletaOpalco: this.id_boleta,
                  palco_status: this.datos_seat.status,
                })
                .then((response) => {
                  if (response.message != 'error') {
                    this.preciosBoletasLocalidadDescuento(this.datos_seat.tipo);

                    this.refrescarvalorwidget();
                    if (
                      this.dateTimeSaleStart == null &&
                      this.dateTimeSaleEnd == null
                    ) {
                      var fechaInicioVenta = moment().format('Y-MM-D HH:mm:s');
                      this.$store.dispatch(
                        'carrito/dateTimeSaleStart',
                        fechaInicioVenta
                      );
                      var fechaFinVenta = moment()
                        .add(10, 'minutes')
                        .format('Y-MM-D HH:mm:s');
                      this.$store.dispatch(
                        'carrito/dateTimeSaleEnd',
                        fechaFinVenta
                      );
                    }
                  } else {
                    if (this.datos_seat.tipo == 1) {
                      var mensajeError =
                        'Error, transaccion en progreso por otro usuario. Escoge otro palco.';
                    } else {
                      var mensajeError =
                        'Error, transaccion en progreso por otro usuario. Escoge otra boleta.';
                    }

                    if (response.data.tope) {
                      var mensajeError =
                        'Usuario excedió el límite máximo de boletas que puede comprar para este evento. Código :002A';
                    }

                    swal('Error!', mensajeError, 'error');
                  }
                });

              //this.$store.dispatch('carrito/preciosBoletasCarrito',this.preciosBoletasLocalidadDescuento);

              //actualiza la grafica de las boletas
              this.$store.dispatch('localidad/listBoletasLocalidad', {
                id_localidad: this.idlocalidad,
                id_evento: this.idEvento,
                codigo_moneda: this.monedaEvento,
              });
              if (this.boleta.status != 12) {
                this.modalCosto = false;
              }
            } else {
              swal(
                'Mensaje',
                'Ha excedido la cantidad maxima de palcos por transacción.',
                'warning'
              );
            }
          }
        } else {
          this.modalfechacupos = true;
          this.fechaventa = this.formatDatetimeString(
            this.evento.fecha_inicio_venta_internet_formateada
          );
          this.fechacupon = this.formatDatetimeString(
            this.evento.fecha_inicio_venta_cupon_formateada
          );
          this.ideventocup = this.evento.id_evento;
          this.validarcupon = false;
          this.validarcuponfecha = false;
          if (this.evento.cupon == 'true') {
            this.validarcupon = true;
          }
          if (this.evento.fechaValidaInicioCuponVenta == 1) {
            this.validarcuponfecha = true;
          }
        }
      },
      async reservarxxx() {
        this.findPuesto();

        this.valida_venta_estado = 0;

        if (this.$store.getters['user/dataUserLogged'].nombre == null) {
          this.$store.state.modalLogin = true;
          return false;
        }
        await axios
          .get(configApi.apiUrl + 'valida_ventas_activas', headers)
          .then((response) => {
            this.valida_venta_estado = response.data[0].cantidad;
          });

        if (this.valida_venta_estado > 0) {
          swal(
            '¡Tiene una transacción pendiente!',
            'Tiene una transacción pendiente de pago, intente nuevamente después de 15 minutos',
            'warning'
          );
          return;
        }

        if (
          this.currentRoute != 'evento' ||
          this.evento.fechaValidaInicioInternet ||
          this.$store.state.carrito.cuponestado
        ) {
          if (this.$store.getters['user/dataUserLogged'].nombre == null) {
            this.$store.state.modalLogin = true;
          } else {
            if (this.countPalcos < 2) {
              await this.$store
                .dispatch('evento/setCantBoleta', {
                  operacion: 'reservar',
                  palco: this.boletaslocalidad.palco,
                  id_evento: this.idEvento,
                  id_localidad: this.boletaslocalidad.id,
                  id_boletaOpalco: this.boleta.id,
                  palco_status: this.boleta.status,
                })
                .then((response) => {
                  if (response.message != 'error') {
                    this.preciosBoletasLocalidadDescuento(
                      this.boletaslocalidad.palco
                    );
                    if (
                      this.dateTimeSaleStart == null &&
                      this.dateTimeSaleEnd == null
                    ) {
                      var fechaInicioVenta = moment().format('Y-MM-D HH:mm:s');
                      this.$store.dispatch(
                        'carrito/dateTimeSaleStart',
                        fechaInicioVenta
                      );
                      var fechaFinVenta = moment()
                        .add(10, 'minutes')
                        .format('Y-MM-D HH:mm:s');
                      this.$store.dispatch(
                        'carrito/dateTimeSaleEnd',
                        fechaFinVenta
                      );
                    }
                  } else {
                    if (this.boletaslocalidad.palco == 1) {
                      var mensajeError =
                        'Error, transaccion en progreso por otro usuario. Escoge otro palco.';
                    } else {
                      var mensajeError =
                        'Error, transaccion en progreso por otro usuario. Escoge otra boleta.';
                    }

                    if (response.data.tope) {
                      var mensajeError =
                        'Usuario excedió el límite máximo de boletas que puede comprar para este evento. Código :002A';
                    }

                    swal('Error!', mensajeError, 'error');
                  }
                });

              //this.$store.dispatch('carrito/preciosBoletasCarrito',this.preciosBoletasLocalidadDescuento);

              //actualiza la grafica de las boletas
              this.$store.dispatch('localidad/listBoletasLocalidad', {
                id_localidad: this.idlocalidad,
                id_evento: this.idEvento,
                codigo_moneda: this.monedaEvento,
              });
              if (this.boleta.status != 12) {
                this.modalCosto = false;
              }
            } else {
              swal(
                'Mensaje',
                'Ha excedido la cantidad maxima de palcos por transacción.',
                'warning'
              );
            }
          }
        } else {
          this.modalfechacupos = true;
          this.fechaventa = this.formatDatetimeString(
            this.evento.fecha_inicio_venta_internet_formateada
          );
          this.fechacupon = this.formatDatetimeString(
            this.evento.fecha_inicio_venta_cupon_formateada
          );
          this.ideventocup = this.evento.id_evento;
          this.validarcupon = false;
          this.validarcuponfecha = false;
          if (this.evento.cupon == 'true') {
            this.validarcupon = true;
          }
          if (this.evento.fechaValidaInicioCuponVenta == 1) {
            this.validarcuponfecha = true;
          }
        }
      },
      getPrecioBoleta() {
        var localidad =
          this.$store.getters['carrito/localidadSelectCarrito'][0];
        if (
          this.$store.getters['evento/listPreventasEvento'] &&
          this.$store.getters['evento/listPreventasEvento'].length > 0
        ) {
          var preventas = this.$store.getters['evento/listPreventasEvento'];
        }
        if (this.boletaslocalidad.palco == 1) {
          var cantidadPreciosLocalidad =
            this.boletaslocalidad.filas[0].puestos[0].palcos[0].palco_eventos[0]
              .precios_monedas_carrito;
        } else {
          var cantidadPreciosLocalidad =
            this.boletaslocalidad.filas[0].puestos[0].boleta_eventos[0]
              .precios_monedas_carrito;
        }

        var indiceMoneda = 1;
        for (var i = cantidadPreciosLocalidad.length - 1; i >= 0; i--) {
          if (indiceMoneda == 1) {
            indiceMoneda = '';
          }
          var total_precio = parseFloat(
            eval('localidad.localidad_evento[0].precio_venta' + indiceMoneda)
          );
          var total_servicio = parseFloat(
            eval('localidad.localidad_evento[0].precio_servicio' + indiceMoneda)
          );

          if (this.tipo_individual == 12) {
            this.$store.state.carrito.vservicio =
              (this.$store.state.carrito.vservicio + total_servicio) / 10;
          } else {
            this.$store.state.carrito.vservicio =
              this.$store.state.carrito.vservicio + total_servicio;
          }

          const array = this.$store.getters['carrito/arrayPreventasSelect'];
          const newArraypreventasmanuales = array.filter(
            (item) => item !== false
          );

          if (preventas) {
            for (var j = preventas.length - 1; j >= 0; j--) {
              var preventa = preventas[j];
              if (
                (preventa.automatica == 0 &&
                  this.$store.getters['carrito/arrayPreventasSelect'].includes(
                    preventa.id
                  )) ||
                preventa.automatica == 1
              ) {
                if (
                  preventa.tipo == 1 ||
                  (preventa.tipo == 2 &&
                    preventa.ids_tribunas.includes(
                      localidad.id_tribuna.toString()
                    )) ||
                  (preventa.tipo == 3 &&
                    preventa.ids_localidades.includes(
                      localidad.id.toString()
                    ) &&
                    (this.$route.name != 'evento' ||
                      preventa.venta_linea == 1) &&
                    ((preventa.automatica == 0 &&
                      this.$store.getters[
                        'carrito/arrayPreventasSelect'
                      ].includes(preventa.id)) ||
                      preventa.automatica == 1))
                ) {
                  if (preventa.automatica == 0) {
                    if (parseFloat(preventa.descuento_servicio) > 0) {
                      if (preventa.tipo_descuento_servicio == 1) {
                        total_servicio =
                          parseFloat(total_servicio) -
                          parseFloat(
                            parseFloat(
                              eval(
                                'localidad.localidad_evento[0].precio_servicio' +
                                  indiceMoneda
                              )
                            ) * parseFloat(preventa.descuento_servicio)
                          );
                      } else {
                        total_servicio =
                          parseFloat(total_servicio) -
                          parseFloat(preventa.descuento_servicio);
                      }
                    }
                    if (parseFloat(preventa.descuento_precio) > 0) {
                      if (preventa.tipo_descuento_precio == 1) {
                        total_precio =
                          parseFloat(total_precio) -
                          parseFloat(
                            parseFloat(
                              eval(
                                'localidad.localidad_evento[0].precio_venta' +
                                  indiceMoneda
                              )
                            ) * parseFloat(preventa.descuento_precio)
                          );
                      } else {
                        total_precio =
                          parseFloat(total_precio) -
                          parseFloat(preventa.descuento_precio);
                      }
                    }
                  }
                  if (
                    preventa.automatica == 1 &&
                    newArraypreventasmanuales.length == 0
                  ) {
                    if (parseFloat(preventa.descuento_servicio) > 0) {
                      if (preventa.tipo_descuento_servicio == 1) {
                        total_servicio =
                          parseFloat(total_servicio) -
                          parseFloat(
                            parseFloat(
                              eval(
                                'localidad.localidad_evento[0].precio_servicio' +
                                  indiceMoneda
                              )
                            ) * parseFloat(preventa.descuento_servicio)
                          );
                      } else {
                        total_servicio =
                          parseFloat(total_servicio) -
                          parseFloat(preventa.descuento_servicio);
                      }
                    }
                    if (parseFloat(preventa.descuento_precio) > 0) {
                      if (preventa.tipo_descuento_precio == 1) {
                        total_precio =
                          parseFloat(total_precio) -
                          parseFloat(
                            parseFloat(
                              eval(
                                'localidad.localidad_evento[0].precio_venta' +
                                  indiceMoneda
                              )
                            ) * parseFloat(preventa.descuento_precio)
                          );
                      } else {
                        total_precio =
                          parseFloat(total_precio) -
                          parseFloat(preventa.descuento_precio);
                      }
                    }
                  }
                }
              }
            }
          }
          if (indiceMoneda == '') {
            indiceMoneda = 1;
          }

          indiceMoneda++;
        }
        return total_servicio + total_precio <= 0
          ? 0
          : total_servicio + total_precio;
      },
      async preciosBoletasLocalidadDescuento(tipoBoleta) {
        //lamt
        //trae la loclaidad x para ver el precio venta y precio servicio
        let data = '' + '/' + this.idlocalidad;
        let localidad = '';
        await axios
          .get(`${configApi.apiUrl}buscarLocalidad?nombre=${data}`, null, {
            headers: headers,
          })
          .then((response) => {
            localidad = response.data.data[0];
          });

        //var localidad = this.$store.getters["carrito/localidadSelectCarrito"];

        if (
          this.$store.getters['evento/listPreventasEvento'] &&
          this.$store.getters['evento/listPreventasEvento'].length > 0
        ) {
          var preventas = this.$store.getters['evento/listPreventasEvento'];
        }

        var preciosBoletas = [];
        if (this.datos_seat.tipo == 1) {
          var cantidadPreciosLocalidad = this.datos_seat.precio_venta;
        } else {
          var cantidadPreciosLocalidad = this.datos_seat.precio_venta;
        }

        const array = this.$store.getters['carrito/arrayPreventasSelect'];
        const newArraypreventasmanuales = array.filter(
          (item) => item !== false
        );

        var indiceMoneda = 1;
        for (var i = cantidadPreciosLocalidad.length - 1; i >= 0; i--) {
          if (indiceMoneda == 1) {
            indiceMoneda = '';
          }
          var total_precio = parseFloat(
            eval('localidad.precio_venta' + indiceMoneda)
          );
          var total_servicio = parseFloat(
            eval('localidad.precio_servicio' + indiceMoneda)
          );
          if (preventas) {
            for (var j = preventas.length - 1; j >= 0; j--) {
              var preventa = preventas[j];
              if (
                (preventa.automatica == 0 &&
                  this.$store.getters['carrito/arrayPreventasSelect'].includes(
                    preventa.id
                  )) ||
                preventa.automatica == 1
              ) {
                if (
                  preventa.tipo == 1 ||
                  (preventa.tipo == 2 &&
                    preventa.ids_tribunas.includes(
                      localidad.id_tribuna.toString()
                    )) ||
                  (preventa.tipo == 3 &&
                    preventa.ids_localidades.includes(
                      localidad.id.toString()
                    ) &&
                    (this.$route.name != 'evento' || preventa.venta_linea == 1))
                ) {
                  if (
                    this.$store.getters['carrito/arrayPreventasSelect'].some(
                      (valor) => valor !== false
                    )
                  ) {
                    if (preventa.automatica == 0) {
                      if (parseFloat(preventa.descuento_servicio) > 0) {
                        if (preventa.tipo_descuento_servicio == 1) {
                          total_servicio =
                            parseFloat(total_servicio) -
                            parseFloat(
                              parseFloat(
                                eval('localidad.precio_servicio' + indiceMoneda)
                              ) * parseFloat(preventa.descuento_servicio)
                            );
                        } else {
                          total_servicio =
                            parseFloat(total_servicio) -
                            parseFloat(preventa.descuento_servicio);
                        }
                      }
                      if (parseFloat(preventa.descuento_precio) > 0) {
                        if (preventa.tipo_descuento_precio == 1) {
                          total_precio =
                            parseFloat(total_precio) -
                            parseFloat(
                              parseFloat(
                                eval('localidad.precio_venta' + indiceMoneda)
                              ) * parseFloat(preventa.descuento_precio)
                            );
                        } else {
                          total_precio =
                            parseFloat(total_precio) -
                            parseFloat(preventa.descuento_precio);
                        }
                      }
                    }
                  } else {
                    if (
                      preventa.automatica == 1 &&
                      newArraypreventasmanuales.length == 0
                    ) {
                      if (parseFloat(preventa.descuento_servicio) > 0) {
                        if (preventa.tipo_descuento_servicio == 1) {
                          total_servicio =
                            parseFloat(total_servicio) -
                            parseFloat(
                              parseFloat(
                                eval('localidad.precio_servicio' + indiceMoneda)
                              ) * parseFloat(preventa.descuento_servicio)
                            );
                        } else {
                          total_servicio =
                            parseFloat(total_servicio) -
                            parseFloat(preventa.descuento_servicio);
                        }
                      }
                      if (parseFloat(preventa.descuento_precio) > 0) {
                        if (preventa.tipo_descuento_precio == 1) {
                          total_precio =
                            parseFloat(total_precio) -
                            parseFloat(
                              parseFloat(
                                eval('localidad.precio_venta' + indiceMoneda)
                              ) * parseFloat(preventa.descuento_precio)
                            );
                        } else {
                          total_precio =
                            parseFloat(total_precio) -
                            parseFloat(preventa.descuento_precio);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          var total = total_servicio + total_precio;

          if (this.boleta.status === 12) {
            var total = (total_servicio + total_precio) / 10;
            tipoBoleta = 3;
          }

          this.$store.dispatch('carrito/preciosBoletasCarrito', {
            precio:
              total + (total * localidad.impuesto) / 100 <= 0
                ? 0
                : total + (total * localidad.impuesto) / 100,
            codigo_moneda: eval('localidad.codigo_moneda' + indiceMoneda),
            localidad_id: localidad.id,
            tipoBoleta: tipoBoleta,
          });
          //preciosBoletas.push({'precio':(total+((total*localidad.localidad_evento[0].impuesto)/100)),'codigo_moneda':eval('localidad.localidad_evento[0].codigo_moneda'+indiceMoneda)});

          if (indiceMoneda == '') {
            indiceMoneda = 1;
          }

          indiceMoneda++;
        }
      },
      async saveAccionPuesto() {
        if (this.boleta.status == 1) {
          var status = 4;
        } else {
          var status = 1;
        }

        var tipoBoleta = '';
        if (this.boletaslocalidad.palco != 1) {
          tipoBoleta = 'boleta';
        } else {
          tipoBoleta = 'palco';
        }

        await this.$store
          .dispatch('puesto/saveAccionPuesto', {
            tipo_boleta: tipoBoleta,
            id_boleta: this.boleta.id,
            status: status,
            nota: this.accionPuesto.nota,
          })
          .then((response) => {
            if (response.message == 'error') {
              if (this.boletaslocalidad.palco == 1) {
                var mensajeError =
                  'Error, transaccion en progreso por otro usuario. Escoge otro palco.';
              } else {
                var mensajeError =
                  'Error, transaccion en progreso por otro usuario. Escoge otra boleta.';
              }
              swal('Error!', mensajeError, 'error');
            }
          });

        this.$store.dispatch('localidad/listBoletasLocalidad', {
          id_localidad: this.idlocalidad,
          id_evento: this.idEvento,
          codigo_moneda: this.monedaEvento,
        });

        this.modalCosto = false;
      },
      async restar_reserva(id) {
        this.valida_venta_estado = 0;

        if (this.$store.getters['user/dataUserLogged'].nombre == null) {
          this.$store.state.modalLogin = true;
          return false;
          //swal("Error!", "Debe Iniciar Sesión!", "error");
        }
        if (
          this.currentRoute != 'evento' ||
          this.evento.fechaValidaInicioInternet ||
          this.$store.state.carrito.cuponestado
        ) {
          if (this.$store.getters['user/dataUserLogged'].nombre == null) {
            this.$store.state.modalLogin = true;
            //swal("Error!", "Debe Iniciar Sesión!", "error");
          } else {
            if (this.countPalcos < 2) {
              // await this.$store.dispatch('carrito/listBoletas',{
              // 	id: this.boleta.id,
              // 	id_evento: this.boleta.id_evento,
              // 	id_puesto: this.boleta.id_puesto,
              //     precio_venta: this.boleta.precio_venta,
              //     precio_servicio: this.boleta.precio_servicio,
              //     impuesto: this.boleta.impuesto,
              //     status: 2,
              //     codigo_moneda: this.boleta.codigo_moneda,
              // });
              //lamt 3
              if (this.datos[0].palco != 1) {
                const fila = JSON.parse(this.datos[0].mapeo);

                for (let i = 0; i < fila.length; i++) {
                  const puesto = fila[i].find((p) => p.id_boleta_Evento == id);

                  if (puesto != undefined) {
                    puesto.status_boleta_Evento = 1;
                    i = fila.length;
                  }
                }

                let code = JSON.stringify(fila);

                let codigolocalidad = this.idlocalidad;
                const data = {
                  id: codigolocalidad,
                  mapeo: code,
                };

                axios
                  .post(`${configApi.apiUrl}ger_mapeo_localidad`, data, {
                    headers: headers,
                  })
                  .then((response) => {
                    console.log('volvi dle cambio');
                  });
              } else {
                const fila = JSON.parse(this.datos[0].mapeo);

                for (let i = 0; i < fila.length; i++) {
                  const puesto = fila[i].find((palco) =>
                    palco.palcos[0].palco_eventos.find((p) => p.id == id)
                  );

                  if (puesto != undefined) {
                    puesto.palcos[0].palco_eventos[0].status = 1;
                    i = fila.length;
                  }
                }

                let code = JSON.stringify(fila);

                let codigolocalidad = this.idlocalidad;
                const data = {
                  id: codigolocalidad,
                  mapeo: code,
                };

                axios
                  .post(`${configApi.apiUrl}ger_mapeo_localidad`, data, {
                    headers: headers,
                  })
                  .then((response) => {
                    console.log('volvi dle cambio');
                  });
              }

              await this.$store
                .dispatch('evento/setCantBoleta', {
                  operacion: 'restar',
                  palco: '',
                  id_evento: this.evento.id,
                  id_localidad: this.idlocalidad,
                  palco_status: 1,
                })
                .then((response) => {
                  //console.log(response);

                  this.refrescarvalorwidget();
                });

              //this.$store.dispatch('carrito/preciosBoletasCarrito',this.preciosBoletasLocalidadDescuento);

              //actualiza la grafica de las boletas
              this.$store.dispatch('localidad/listBoletasLocalidad', {
                id_localidad: this.idlocalidad,
                id_evento: this.idEvento,
                codigo_moneda: this.monedaEvento,
              });
              if (this.boleta.status != 12) {
                this.modalCosto = false;
              }
            } else {
              swal(
                'Mensaje',
                'Ha excedido la cantidad maxima de palcos por transacción.',
                'warning'
              );
            }
          }
        } else {
          this.modalfechacupos = true;
          this.fechaventa = this.formatDatetimeString(
            this.evento.fecha_inicio_venta_internet_formateada
          );
          this.fechacupon = this.formatDatetimeString(
            this.evento.fecha_inicio_venta_cupon_formateada
          );
          this.ideventocup = this.evento.id_evento;
          this.validarcupon = false;
          this.validarcuponfecha = false;
          if (this.evento.cupon == 'true') {
            this.validarcupon = true;
          }
          if (this.evento.fechaValidaInicioCuponVenta == 1) {
            this.validarcuponfecha = true;
          }
        }
      },
      async cargarMapeo() {
        document.getElementById('seats_container').innerHTML = '';
        this.$refs.seatsContainer.innerHTML = '';

        const script = document.createElement('script');
        script.src = '/js/seatmap.canvas.js'; // Ruta a tu archivo image-map-pro.min.js
        script.async = true;

        script.onload = () => {
          this.$nextTick(() => {
            let seatmap = new window.SeatMapCanvas('#seats_container', {
              legend: true,
              resizable: true,
              style: {
                seat: {
                  hover: this.color,
                  color: (seat) => seat.data,
                  selected: this.selectedColorSelect,
                  check_icon_color: '#339966',
                  inhabilitados: '#cfff04',
                  not_salable: this.selectedColorOcupados,
                  focus: '#FFCC99',
                  radius: 12,
                },
                legend: {
                  font_color: '#000000',
                  show: false,
                },
                block: {
                  title_color: '#000000',
                },
                label: {
                  radius: 0,
                },
              },
            });
            /* Funcion para deseleccionar */
            if (
              localStorage.getItem('seatId') != null ||
              localStorage.getItem('blockId') != null
            ) {
              let seatId = localStorage.getItem('seatId');
              let blockId = localStorage.getItem('blockId');
              localStorage.removeItem('seatId');
              localStorage.removeItem('blockId');
              let seat = seatmap.data.getSeat(seatId, blockId);
              seat.svg.unSelect();
              updateSelectedSeats();
            }

            seatmap.eventManager.addEventListener('SEAT.CLICK', (seat) => {
              if (this.$store.getters['user/dataUserLogged'].nombre == null) {
                this.$router.push({ path: '/login' });
                //window.location.push("/login")
                //location.replace('/login')
                //this.$store.state.modalLogin = true;
              } else {
                if (
                  !seat.isSelected() &&
                  seat.item.salable === true &&
                  seat.item.custom_data.status === 1
                ) {
                  seat.select();

                  let boletasReservadas =
                    JSON.parse(localStorage.getItem('boletasReservadasPV')) ||
                    [];
                  boletasReservadas.push(seat.item.id);
                  localStorage.setItem(
                    'boletasReservadasPV',
                    JSON.stringify(boletasReservadas)
                  );

                  if (this.datos[0].palco != 1) {
                    const fila = JSON.parse(this.datos[0].mapeo);

                    for (let i = 0; i < fila.length; i++) {
                      const puesto = fila[i].find(
                        (p) => p.id_boleta_Evento == seat.item.id
                      );

                      if (puesto != undefined) {
                        puesto.status_boleta_Evento = 2;
                        i = fila.length;
                      }
                    }

                    let code = JSON.stringify(fila);

                    let codigolocalidad = this.idlocalidad;
                    const data = {
                      id: codigolocalidad,
                      mapeo: code,
                    };

                    axios
                      .post(`${configApi.apiUrl}ger_mapeo_localidad`, data, {
                        headers: headers,
                      })
                      .then((response) => {
                        console.log('volvi dle cambio');
                      });
                  } else {
                    const fila = JSON.parse(this.datos[0].mapeo);

                    for (let i = 0; i < fila.length; i++) {
                      const puesto = fila[i].find((palco) =>
                        palco.palcos[0].palco_eventos.find(
                          (p) => p.id == seat.item.id
                        )
                      );

                      if (puesto != undefined) {
                        puesto.palcos[0].palco_eventos[0].status = 2;
                        i = fila.length;
                      }
                    }

                    let code = JSON.stringify(fila);

                    let codigolocalidad = this.idlocalidad;
                    const data = {
                      id: codigolocalidad,
                      mapeo: code,
                    };

                    axios
                      .post(`${configApi.apiUrl}ger_mapeo_localidad`, data, {
                        headers: headers,
                      })
                      .then((response) => {
                        console.log('volvi dle cambio');
                      });
                  }

                  //
                  ///lamt this.datos_seat.tipo
                  // marcar Si es palco
                  this.id_boleta = seat.item.id;
                  this.datos_seat.tipo = seat.item.custom_data.tipo;
                  this.datos_seat.status = seat.item.custom_data.status;
                  this.datos_seat.precio_venta =
                    seat.item.custom_data.price_venta;
                  this.datos_seat.precio_servicio =
                    seat.item.custom_data.price_servicio;

                  if (this.datos_seat.tipo == 1 || this.datos_seat.tipo == 2)
                    this.reservar();

                  this.colorSeat = seat.item.color;
                } else {
                  let seatId = seat.item.id;
                  this.restar_reserva(seatId);
                  seat.unSelect();
                }
                updateSelectedSeats();
              }
            });

            // seatmap.zoomManager.zoomToVenue();

            const dibujarLocalidad = function (
              datos,
              colorFondo,
              palco_evento
            ) {
              let data = datos;
              let block_colors = [colorFondo];

              let blocks = [];
              let last_x = 0;
              let j = 0;
              let color = block_colors[j];
              let seats = [];
              let cell_count = 0;
              let row_count = 0;
              let estado = false;
              let selected = false;
              let nro = 1;
              //let k = 0;
              let contador = 0;
              let nomboleta = '';
              let tipo = '';

              for (let i = 0; i < data.length; i++) {
                const fila = JSON.parse(data[i].mapeo);

                if (data[i].palco == null && data[i].silleteria == null) {
                  nomboleta = 'Boleta';
                  tipo = 4;
                } else if (data[i].palco == null && data[i].silleteria == '1') {
                  nomboleta = 'B. Numerada';
                  tipo = 2;
                } else {
                  nomboleta = 'Palco';
                  tipo = 1;
                }

                const puestos = fila;

                let lastY = 0;

                //row_count = row_count + 1;
                //cell_count = 0;
                let seats = [];
                for (let j = 0; j < puestos.length; j++) {
                  const puestos_internos = puestos[j];
                  row_count = row_count + 1;

                  cell_count = 0;

                  for (let k = 0; k < puestos_internos.length; k++) {
                    if (puestos_internos[k].numpalco === '') {
                      cell_count++;
                    } else {
                      let x = cell_count * 33 + last_x;
                      let y = row_count * 30;

                      lastY = y;

                      estado = false;
                      selected = false;

                      if (tipo == 1) {
                        if (
                          puestos_internos[k].palcos[0].palco_eventos[0]
                            .status == 1
                        ) {
                          estado = true;
                        }
                        if (
                          puestos_internos[k].palcos[0].palco_eventos[0]
                            .status == 2
                        ) {
                          selected = false;
                          estado = true;
                        }
                      } else {
                        if (puestos_internos[k].status_boleta_Evento == 1) {
                          estado = true;
                        }
                        if (puestos_internos[k].status_boleta_Evento == 2) {
                          selected = false;
                          status = 2;
                          estado = true;
                        }
                        if (puestos_internos[k].status_boleta_Evento == 4) {
                          selected = false;
                          status = 4;
                          estado = true;
                        }
                        if (puestos_internos[k].status_boleta_Evento == 7) {
                          selected = false;
                          status = 7;
                          estado = true;
                        }
                      }

                      let identificador = '';
                      let precio_venta = '';
                      let precio_servicio = '';
                      let status = '';
                      let nom = '';
                      if (tipo == 4) {
                        identificador =
                          puestos_internos[k].boleta_eventos[0].id;
                        precio_venta =
                          puestos_internos[k].boleta_eventos[0]
                            .precios_monedas[0].precio_venta;
                        precio_servicio =
                          puestos_internos[k].boleta_eventos[0]
                            .precios_monedas[0].precio_servicio;
                        status = puestos_internos[k].status_boleta_Evento;
                        nom = puestos_internos[k].numpalco;
                      } else if (tipo == 2) {
                        identificador = puestos_internos[k].id_boleta_Evento;
                        precio_venta = puestos_internos[k].precio_venta;
                        precio_servicio = puestos_internos[k].precio_servicio;
                        status = puestos_internos[k].status_boleta_Evento;
                        nom = puestos_internos[k].numpalco;
                      } else {
                        identificador =
                          puestos_internos[k].palcos[0].palco_eventos[0].id;
                        precio_venta =
                          puestos_internos[k].palcos[0].palco_eventos[0]
                            .precios_monedas[0].precio_venta;
                        precio_servicio =
                          puestos_internos[k].palcos[0].palco_eventos[0]
                            .precios_monedas[0].precio_servicio;
                        status =
                          puestos_internos[k].palcos[0].palco_eventos[0].status;
                        nom = puestos_internos[k].numero;
                      }

                      let seat = {
                        id: identificador,
                        x: x,
                        y: y,
                        color: data[i].coloractivos,
                        salable: estado,
                        selected: selected,
                        custom_data: {
                          any: 'thingsb',
                          price: precio_venta + precio_servicio,
                          price_venta: precio_venta,
                          price_servicio: precio_servicio,
                          basket_name: `${nomboleta} :  ${nom}`,
                          tipo: tipo,
                          status: status,
                        },
                        note: 'note test',
                        tags: {
                          any: 'thingsb',
                          price: precio_venta + precio_servicio,
                          basket_name: ` ${cell_count} ${row_count} `,
                        },
                        title: `${nomboleta} :  ${nom} `,
                      };

                      cell_count++;
                      nro++;
                      seats.push(seat);
                    }
                  }
                }

                let block = {
                  id: `block-${data[i].localidad_id}`,
                  title: `block-${data[i].localidad_id}`,
                  labels: puestos.map((fila, indexFila) => {
                    const filasPorArray = puestos.length;
                    const arraysPorFilas = contador;
                    let nombreFila = '';
                    let cantidadPuestos = fila.length;
                    //let f = 0;

                    for (let f = 0; f < cantidadPuestos; f++) {
                      if (fila[f].numpalco != '') {
                        nombreFila = fila[f].fila_nombre;
                        f = cantidadPuestos;
                      }
                    }

                    let y;

                    if (arraysPorFilas === 0) {
                      y = (indexFila + 1) * 30;
                    } else {
                      if (arraysPorFilas !== 0) {
                        // Para los siguientes arrays, aplica la condición
                        y = lastY - filasPorArray * 30 + (indexFila + 1) * 30;
                      } else if (filasPorArray != 0) {
                        y = (indexFila + 1) * 30;
                      }
                    }

                    return {
                      title: nombreFila,
                      x: -45,
                      y: y,
                    };
                  }),
                  color: data[i].coloractivos,
                  seats: seats,
                };

                contador++;
                blocks.push(block);
                if (i == 66) {
                  i = data.length;
                }
              }

              /*let block = {
                "id": `block-${j}`,
                "title": '',
                "labels": [],
                "color": color,
                "seats": seats
              };

              blocks.push(block);*/
              //seatmap.data.replaceData(blocks);
              seatmap.data.replaceData(blocks);

              d3.selectAll('.seat')
                .data(blocks.flatMap((block) => block.seats))
                .attr('fill', (d) => {
                  switch (d.custom_data.status) {
                    case 1:
                      return d.color;

                    case 2:
                      d3.select(this).style('pointer-event', 'none');
                      return '#fc6500';
                    // Color para el estado 2
                    case 4:
                      return '#cfff04'; // Color para el estado 4
                    case 7:
                      return '#0000ff';

                    default:

                    /*  console.log(typeof d.custom_data.status);
                        console.log(d) */
                  }
                });

              let asientos = blocks[0].seats;

              // Encontrar el asiento con estado 2
              const asientoConEstado2 = asientos.filter(
                (asiento) => asiento.custom_data.status === 2
              );

              // Imprimir el asiento encontrado en la consola
            };

            const updateSeatColor = (seatId, newColor) => {
              const seat = seatmap.data.getSeat(seatId);
              if (seat) {
                seat.color = newColor;
                seatmap.data.updateSeat(seat);
              }
            };

            updateSeatColor();

            const unselectSeat = function () {
              let seatId = $(this).attr('seat-id');
              let blockId = $(this).attr('block-id');
              let seat = seatmap.data.getSeat(seatId, blockId);
              seat.svg.unSelect();
              updateSelectedSeats();
            };

            const updateSelectedSeats = function () {
              let selectedSeats = seatmap.data.getSelectedSeats();
              let seatsTemplateHtml = ``;
              let seatsTemplateHtmlTotal = ``;
              let cantidadPuestos = '';
              let deleteSeat = '';
              if (selectedSeats.length === 0) {
                cantidadPuestos = `
                <div class="d-inline-block">
                 <span block class="font-weight-bold float-left">0 Puestos Seleccionados</span>

                 </div>
                `;
              }

              if (selectedSeats.length === 0) {
                seatsTemplateHtmlTotal = `




                  <div>
                    <div class="d-flex justify-content-between fixed">
                      <div><h5 class="onSurfaceVariant--text font-weight-bold">Total:</h5></div>
                      <div>

                        <h5 class="onSurfaceVariant--text font-weight-bold"> $ 0</h5>
                      </div>
                    </div>
                    `;
              }

              for (let i = 0; i < selectedSeats.length; i++) {
                let selectedSeat = selectedSeats[i];

                let priceFormatted =
                  selectedSeat.custom_data.price.toLocaleString('es-CO', {
                    style: 'currency',
                    currency: 'COP',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  });

                let html = `

                      <div id="list-example" class="card my-4 list-group">
                        <ul class="list-group list-group-flush d-flex">
                          <li class="list-group-item ">
                            <div class="d-flex justify-content-between ">
                              <h6 class="text-left font-weight-bold"><span class="mdi mdi-circle pr-2" style="color: ${selectedSeat.color};"></span>${selectedSeat.title}</h6>

                              <h6 class="text-right float-right">${priceFormatted}</h6>
                              <div class="unselect-seat text-center cursor-pointer " seat-id="${selectedSeat.id}" block-id="${selectedSeat.block.id}">
                                <span class="mdi mdi-close-circle-outline  red--text" style="cursor: pointer;" ></span>
                              </div>
                            </div>


                            <h6 class="card-subtitle mb-2" style="color: ${selectedSeat.color};">${selectedSeat.block.id} </h6>
                          </li>
                      </div>
                      `;
                seatsTemplateHtml += html;

                deleteSeat = `
                <v-icon v-if="product.id != false" @click="restar_reserva(product.id)" class="red--text mr-4"
                              right>
                              mdi-close-circle-outline
                            </v-icon>`;
              }

              if (selectedSeats.length > 0) {
                let totalPrice = selectedSeats.reduce(
                  (accumulator, currentValue) =>
                    accumulator + currentValue.custom_data.price,
                  0
                );
                let priceFormatted = totalPrice.toLocaleString('es-CO', {
                  style: 'currency',
                  currency: 'COP',
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                });
                let seatDesc =
                  selectedSeats.length === 1
                    ? '1 puesto seleccionado'
                    : `${selectedSeats.length} puestos selecionados`;
                seatsTemplateHtmlTotal = `

                      <div>
                        <div class="d-flex justify-content-between">
                          <div><h5 class="onSurfaceVariant--text font-weight-bold">Total:</h5></div>
                          <div>

                            <h5 class="onSurfaceVariant--text font-weight-bold">${priceFormatted}</h5>
                          </div>



                        </div>
                        <div class="card-footer text-center">
                          <small class="text-muted"> ${seatDesc}</small>
                        </div>
                      </div>



                      `;

                if (selectedSeats.length > 0) {
                  cantidadPuestos = `
                 <span class="font-weight-bold float-left">${seatDesc}</span>
                `;
                }
              }
              $('.deleteSeat').html(deleteSeat);
              $('.cantidadPuestos').html(cantidadPuestos);
              $('.selected-seats').html(seatsTemplateHtml);
              $('.selected-seats-total').html(seatsTemplateHtmlTotal);

              $('.unselect-seat').on('click', unselectSeat);
            };

            dibujarLocalidad(
              this.datos,
              this.selectedColorFondo,
              this.palco_evento
            );
            updateSelectedSeats();

            // Botón para hacer zoom out
            $('#zoomout-button').on('click', function () {
              seatmap.zoomManager.zoomToVenue();
            });

            // Botón para hacer zoom a un bloque específico
            $('.zoom-to-block').on('click', function (a) {
              let localidadId = $(this).attr('data-localidad-id');
              seatmap.zoomManager.zoomToBlock(localidadId);
            });

            // Mostrar asientos seleccionados en consola
            $('#get-selected-seats').on('click', function (a) {
              let selectedSeats = seatmap.data.getSelectedSeats();
            });

            // Alternar modo oscuro
            $('#dark-mode-btn').on('click', function () {
              $('html').toggleClass('dark');
            });
          });
        };
        document.body.appendChild(script);
      },
    },
    async mounted() {
      await this.cargarMapeo();

      this.$nextTick(() => {
        setTimeout(() => {
          // Obtener la estructura desde localStorage
          const estadoGuardado = localStorage.getItem('estadoVuex');

          // Asegurarse de que haya un estado guardado y establecerlo en Vuex si existe
          if (estadoGuardado) {
            this.$store.replaceState(JSON.parse(estadoGuardado));
          }
          this.refrescarvalorwidget();
        }, 1000);
      });
      //await this.refrescarvalorwidget();
    },
    async updated() {},
    watch: {
      async restarSelect() {
        var rr = this.restarSelect.split('/');

        let seatId = rr[0];
        let blockId = 'block-' + rr[1];

        localStorage.setItem('seatId', seatId);
        localStorage.setItem('blockId', blockId);

        this.cargarMapeo();
      },
      async cantselect() {
        if (this.$store.getters['user/dataUserLogged'].nombre == null) {
          this.$router.push({ path: '/login' });
        } else {
          if (this.cantselect != null && this.cantselect != 'null') {
            await this.Sumar_reserva();

            await this.refrescarvalorwidget();
          }
        }
      },
      async refrescarmapa() {
        const filtro = {
          id_evento: this.idEvento,
          id_localidad: this.idlocalidad,
        };
        this.datos = [];
        this.cargarMapeo();
        await axios
          .post(`${configApi.apiUrl} ger_mapeo_localidad`, filtro, {
            headers: headers,
          })
          .then((response) => {
            this.palco_evento = response.data.puestos_palco;
            this.datos = response.data.resultado;
            this.color = response.data.resultado[0].coloractivos;
            this.selectedColorOcupados =
              response.data.resultado[0].colorocupados;
            this.selectedColorSelect = response.data.resultado[0].colorselect;
            this.selectedColorFondo = response.data.resultado[0].colorfondo;
            this.cargarMapeo();
          });
      },
      async idlocalidad(after, before) {
        window.location.hash = '#boletasxlocalidadcomponent';
        await this.$store.dispatch('localidad/listBoletasLocalidad', {
          id_localidad: after,
          id_evento: this.idEvento,
          codigo_moneda: this.monedaEvento,
        });
      },
      async idEvento(after, before) {
        await this.$store.dispatch('localidad/listBoletasLocalidad', {
          id_localidad: this.idlocalidad,
          id_evento: after,
          codigo_moneda: this.monedaEvento,
        });
      },
      preciosBoletasCarrito() {
        return this.$store.getters['carrito/preciosBoletasCarrito'];
      },
      totalValorBoletasCarrito() {
        var preciosBoletasCarritoMonedaActual = this.$store.getters[
          'carrito/preciosBoletasCarrito'
        ].filter((item) => item.codigo_moneda == this.monedaSelectShopEvento);
        if (
          preciosBoletasCarritoMonedaActual &&
          preciosBoletasCarritoMonedaActual.length > 0
        ) {
          var total = 0;
          for (
            var i = preciosBoletasCarritoMonedaActual.length - 1;
            i >= 0;
            i--
          ) {
            total += preciosBoletasCarritoMonedaActual[i].precio;
          }
          return this.formatNumber(total);
        } else {
          return 0;
        }
      },
      localidadSelectCarrito() {
        return this.$store.getters['carrito/localidadSelectCarrito'];
      },
    },
    computed: {
      boletasLocalidadCount() {
        let count = 0;
        this.$store.state.carrito.preciosBoletasCarrito.forEach((e) => {
          if (e.localidad_id == this.boletaslocalidad.id) {
            count++;
          }
        });
        return count;
      },
      evento() {
        return this.$store.getters['evento/evento'];
      },
      cantBoleta() {
        return this.$store.getters['evento/cantBoleta'];
      },
      cantBoletaTotal() {
        return this.$store.getters['evento/cantBoletaTotal'];
      },
      boletaslocalidad() {
        return this.$store.getters['localidad/listBoletasLocalidad'];
      },
      listBoletasLocalidadDisponibilidad() {
        return this.$store.getters[
          'localidad/listBoletasLocalidadDisponibilidad'
        ];
      },
      listLocalidadesEventoAuditorio_mapeado() {
        return this.$store.getters[
          'auditorio_mapeado/listLocalidadesEventoAuditorio_mapeado'
        ];
      },
      usuarioAuth() {
        return this.$store.getters['user/dataUserLogged'];
      },
      currentRoute() {
        return this.$router.currentRoute.name;
      },
      /*puestosdisponibles() {
                        this.disponibles = 0;
                      this.reservados = 0;
                      this.pagos_parcial = 0;
                      this.ocupados = 0;
                      this.inhabilitados = 0;
                      var total = 0;
                      if (this.boletaslocalidad.length != 0) {
          for (var i = 0; i < this.boletaslocalidad.filas.length; i++) {
            for (
                      var j = 0;
                      j < this.boletaslocalidad.filas[i].puestos.length;
                      j++
                      ) {
              //boletas
              if (
                      this.boletaslocalidad.filas[i].puestos[j].boleta_eventos.length !=
                      0
                      ) {
                switch (
                      this.boletaslocalidad.filas[i].puestos[j].boleta_eventos[0]
                      .status
                      ) {
                  case 1:
                      this.disponibles = parseInt(this.disponibles) + 1;
                      break;
                      case 2:
                      this.reservados = parseInt(this.reservados) + 1;
                      break;
                      case 3:
                      this.pagos_parcial = parseInt(this.pagos_parcial) + 1;
                      break;
                      case 4:
                      this.inhabilitados = parseInt(this.inhabilitados) + 1;
                      break;
                      default:
                      this.ocupados = parseInt(this.ocupados) + 1;
                      break;
                }
              }
                      //palcos
                      if (
                      this.boletaslocalidad.filas[i].puestos[j].palcos.length != 0 &&
                      (j % this.boletaslocalidad.puestosxpalco == 0 || j == 0)
                      ) {
                for (
                      var k =
                      this.boletaslocalidad.filas[i].puestos[j].palcos.length - 1;
                  k >= 0;
                      k--
                      ) {
                  if (
                      this.boletaslocalidad.filas[i].puestos[j].palcos[k]
                      .palco_eventos.length != 0
                      ) {
                    switch (
                      this.boletaslocalidad.filas[i].puestos[j].palcos[k]
                      .palco_eventos[0].status
                      ) {
                      case 1:
                      this.disponibles = parseInt(this.disponibles) + 1;
                      break;
                      case 2:
                      this.reservados = parseInt(this.reservados) + 1;
                      break;
                      case 3:
                      this.pagos_parcial = parseInt(this.pagos_parcial) + 1;
                      break;
                      case 4:
                      this.inhabilitados = parseInt(this.inhabilitados) + 1;
                      break;
                      default:
                      this.ocupados = parseInt(this.ocupados) + 1;
                      break;
                    }
                  }
                }
              }
                      total = parseInt(total) + 1;
            }
          }
        }
                      if (
                      parseInt(this.disponibles) +
                      parseInt(this.reservados) +
                      parseInt(this.ocupados) +
                      parseInt(this.pagos_parcial) +
                      parseInt(this.inhabilitados) ==
                      0
                      ) {
          if (this.boletaslocalidad.palco == 1) {
                        this.disponibles = total / this.boletaslocalidad.puestosxpalco;
          } else {
                        this.disponibles = total;
          }
        }
                      return {
                        disponibles: this.disponibles,
                      reservados: this.reservados,
                      pagos_parcial: this.pagos_parcial,
                      ocupados: this.ocupados,
                      inhabilitados: this.inhabilitados,
        };
      },*/
      puestosmayor() {
        var mayor = 0;
        var puestosmayor = 0;
        for (var i = this.boletaslocalidad.filas.length - 1; i >= 0; i--) {
          if (mayor < this.boletaslocalidad.filas[i].puestos.length) {
            mayor = this.boletaslocalidad.filas[i].puestos.length;
          }
        }
        if (
          this.boletaslocalidad.palco == 1 &&
          this.boletaslocalidad.puestosxpalco != null
        ) {
          puestosmayor =
            (parseInt(mayor) / this.boletaslocalidad.puestosxpalco) * 90;
        } else {
          puestosmayor = parseInt(mayor) * 90;
        }
        return puestosmayor;
      },
      dateTimeSaleStart() {
        return this.$store.getters['carrito/dateTimeSaleStart'];
      },
      dateTimeSaleEnd() {
        return this.$store.getters['carrito/dateTimeSaleEnd'];
      },
      countBoletas() {
        return this.$store.getters['carrito/countBoletas'];
        /* var lasBoletas = [];
          var losPalcos = [];

          for (var i = 0; i < this.listLocalidadesEventoAuditorio_mapeado.length; i++) {
          if (this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id] != null) {
            if (this.listLocalidadesEventoAuditorio_mapeado[i].palco == 1) {
                        losPalcos = losPalcos.concat(this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]);
            } else {
                        lasBoletas = lasBoletas.concat(this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]);
            }
                      this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id].length;
          }
          }

                      return lasBoletas.length; */
      },
      countPalcos() {
        return this.$store.getters['carrito/countPalcos'];
        /* var lasBoletas = [];
          var losPalcos = [];

          for (var i = 0; i < this.listLocalidadesEventoAuditorio_mapeado.length; i++) {
          if (this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id] != null) {
            if (this.listLocalidadesEventoAuditorio_mapeado[i].palco == 1) {
                        losPalcos = losPalcos.concat(this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]);
            } else {
                        lasBoletas = lasBoletas.concat(this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id]);
            }
                      this.cantBoleta[this.listLocalidadesEventoAuditorio_mapeado[i].id].length;
          }
          }

                      return losPalcos.length;*/
      },
    },
  };
</script>

<style>
  .multi-select-enable .seatmap-svg .stage .blocks .block {
    cursor: crosshair;
  }

  .multi-select-enable
    .seatmap-svg
    .stage
    .blocks
    .block
    .masks
    .seat-level-mask {
    cursor: crosshair !important;
  }

  .multi-select-enable .seatmap-svg .stage .blocks .block .seats .seat {
    cursor: crosshair;
  }

  .multi-select-enable
    .seatmap-svg
    .stage
    .blocks
    .block
    .seats
    .seat.selected {
    cursor: crosshair;
  }

  .seatmap-svg {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .seatmap-svg.zoom-level-SEAT .stage .blocks .block .masks .seat-level-mask {
    cursor: none;
  }

  .seatmap-svg.zoom-level-BLOCK .stage .blocks .block .masks .seat-level-mask {
    cursor: none;
  }

  .seatmap-svg.zoom-level-VENUE .stage .blocks .block {
    filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.61));
  }

  .seatmap-svg.zoom-level-VENUE .stage .blocks .block:hover {
    transform: scale(1.02);
    filter: drop-shadow(0px 0px 14px rgba(0, 0, 0, 0.7));
  }

  .seatmap-svg.zoom-level-VENUE .stage .blocks .block .masks .seat-level-mask {
    cursor: none;
  }

  .seatmap-svg .zoom-out-bg {
    cursor: zoom-out;
    fill: transparent;
  }

  .seatmap-svg .stage .blocks .block {
    cursor: pointer;
    transition-property: transform, filter;
    transition-duration: 0.17s;
    transition-timing-function: ease-in-out;
    filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0));
  }

  .seatmap-svg .stage .blocks .block .bounds .block-hull-border {
    stroke-linejoin: round;
    opacity: 0.5;
  }

  .seatmap-svg .stage .blocks .block .bounds .block-hull {
    stroke-linejoin: round;
    cursor: move;
  }

  .seatmap-svg .stage .blocks .block .masks .venue-level-mask {
    transition-property: opacity;
    transition-duration: 0.5s;
    transition-delay: 0.2s;
    transition-timing-function: ease-in-out;
    stroke-linejoin: round;
    opacity: 1;
  }

  .seatmap-svg .stage .blocks .block .masks .block-level-mask {
    transition-property: opacity;
    transition-duration: 0.5s;
    transition-delay: 0.2s;
    transition-timing-function: ease-in-out;
    stroke-linejoin: round;
    opacity: 0.7;
  }

  .seatmap-svg .stage .blocks .block .masks .seat-level-mask {
    transition-property: opacity;
    transition-duration: 0.5s;
    transition-delay: 0.2s;
    transition-timing-function: ease-in-out;
    stroke-linejoin: round;
    opacity: 0;
  }

  .seatmap-svg .stage .blocks .block .masks .bound-hide {
    transition-property: opacity;
    transition-duration: 0.5s;
    transition-delay: 0.2s;
    transition-timing-function: ease-in-out;
    pointer-events: none;
    opacity: 0;
  }

  .seatmap-svg .stage .blocks .block .info .title {
    text-anchor: middle;
    dominant-baseline: central;
    pointer-events: none;
  }

  .seatmap-svg .stage .blocks .block .seats .seat {
    cursor: copy;
  }

  .seatmap-svg .stage .blocks .block .seats .seat.selected {
    cursor: pointer;
  }

  .seatmap-svg .stage .blocks .block .seats .seat .label-text {
    text-anchor: middle;
    dominant-baseline: central;
  }

  .seatmap-svg .stage .blocks .block .labels .label circle {
    stroke: rgba(0, 0, 0, 0.2);
  }

  .seatmap-svg .stage .blocks .block .labels .label .label-text {
    text-anchor: middle;
    dominant-baseline: central;
  }

  .seatmap-svg .stage .blocks .block .zoom-layers-container .zoom-layer-hull {
    stroke-width: 80px;
    stroke-linejoin: round;
  }

  @media (any-pointer: coarse) {
    .seatmap-svg .stage .blocks .search-circle {
      display: none;
    }
  }

  .seatmap-svg .stage .search-circle {
    opacity: 0;
    transition-property: opacity;
    transition-duration: 0.2s;
    transition-delay: 0;
    transition-timing-function: ease-in-out;
  }

  .seatmap-svg .stage .search-circle .circle {
    fill: rgba(0, 0, 0, 0);
    pointer-events: none;
    stroke: rgba(0, 0, 0, 0.4);
    stroke-width: 4px;
  }

  .seatmap-svg .stage .search-circle.hide {
    transition-property: opacity;
    transition-duration: 0.2s;
    transition-delay: 0;
    transition-timing-function: ease-in-out;
    opacity: 0;
  }

  .seatmap-svg .stage .search-circle.show {
    transition-property: opacity;
    transition-duration: 0.2s;
    transition-delay: 0;
    transition-timing-function: ease-in-out;
    opacity: 1;
  }

  .seatmap-svg .legend .legend-item circle {
    stroke: #adadad;
    stroke-width: 1px;
  }

  .seatmap-svg .legend .legend-item text {
    text-anchor: start;
    dominant-baseline: central;
  }

  #seats_container {
    display: flex;
    height: 500px;
  }
  /*
  @media (min-width: 960px) {
    #seats_container {
      height: 500px;
    }
  }*/

  .blocks .info .title {
    background: #000000;
  }

  .contenedor {
    display: flex;
    justify-content: space-between;
  }
</style>
